import styled from 'styled-components';

export const RailInsightsStyles = styled.section``;
